import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme  } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';
import App from './App';
import { store } from './store';
import './styles/Tokens.css';
import './styles/Icons.css';
import './styles/Buttons.css';
import 'antd/dist/reset.css';
import './assets/styles/global.css';
import './assets/styles/variables.css';

dayjs.extend(relativeTime);
dayjs.locale('en');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ConfigProvider
          theme={{
            algorithm: theme.darkAlgorithm,
            token: {
              colorPrimary: '#3b82f6',
              colorBgBase: '#0f1226',
              colorBgContainer: '#15182e',
              colorBgElevated: '#1c2030',
              colorBorder: 'rgba(255,255,255,0.08)',
              colorText: '#f1f5f9',
              colorTextSecondary: '#94a3b8',
              borderRadius: 12,
            },
          }}
        >
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);